// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609280223/js/" + chunkId + "." + {"44":"1145a9f5","225":"77a20865","481":"27de9ec2","486":"42b3e8ec","770":"dcaebebd"}[chunkId] + ".0.35830657307479585.chunk.js";
};